import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { deleteContact, getContacts } from "../../redux/actions/contactAction";
import { confirmPopup } from "primereact/confirmpopup";

export default function Index() {
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getContacts());
    }, [dispatch]);

    let { contacts } = useSelector((state) => state.contact);

    const [search, setSearch] = useState("");

    const getFilteredData = (data, search) => {
        if (search.length) {
            data = data.filter(
                (item) =>
                    item?.fullName?.toLowerCase()?.includes(search.toLowerCase())
                    || item?.email?.toLowerCase()?.includes(search.toLowerCase())
                    || item?.subject?.toLowerCase()?.includes(search.toLowerCase())
                    || item?.message?.toLowerCase()?.includes(search.toLowerCase())

            );
        }
        return data;
    };

    contacts = getFilteredData(contacts, search);

    const onDelete = (e, id) => {
        confirmPopup({
            target: e.currentTarget,
            message: "Are you sure you want to delete this contact? This action will permanently delete the user account. This action cannot be undone.",
            icon: "pi pi-exclamation-triangle",
            accept: () => dispatch(deleteContact(id)),
            reject: () => { },
        });
    };

    return {
        contacts,
        history,
        search,
        setSearch,
        dispatch,
        onDelete
    };
}
